import { render, staticRenderFns } from "./AssignedCardsModal.vue?vue&type=template&id=ce3ebd50"
import script from "./AssignedCardsModal.vue?vue&type=script&lang=ts"
export * from "./AssignedCardsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports